@if (isInitialLoading) {
    <div style="margin: 12px">
        <fa-icon class="fa-spin" [icon]="faSpinner"></fa-icon>
        Loading job type summary...
    </div>
}
<div [hidden]="isInitialLoading">
    <div class="row action-toolbar" style="margin-top: 20px">
        <div class="col-12">
            <form class="form-inline">
                <grid-export [grid]="summaryGrid" [name]="'Job Type Summary'"></grid-export>

                <div class="input-header-group">
                    <span class="input-header">Years</span>
                    <wj-multi-select
                        [itemsSource]="availableYears"
                        [checkedMemberPath]="'checked'"
                        [placeholder]="'Choose Years'"
                        style="width: 150px"
                        [selectedValuePath]="'value'"
                        [displayMemberPath]="'display'"
                        [showSelectAllCheckbox]="true"
                        (checkedItemsChanged)="yearsChanged()"
                    ></wj-multi-select>
                </div>

                <div class="input-header-group">
                    <span class="input-header">Job Status</span>
                    <wj-multi-select
                        name="jobTypeSummaryStatus"
                        (checkedItemsChanged)="jobStatusChanged()"
                        [itemsSource]="statusOptions"
                        [displayMemberPath]="'display'"
                        [checkedMemberPath]="'$checked'"
                        [showSelectAllCheckbox]="true"
                    ></wj-multi-select>
                </div>

                <div class="input-header-group">
                    <span class="input-header">Job Type</span>
                    <wj-multi-select
                        name="jobTypeSummaryTypes"
                        style="width: 220px"
                        [itemsSource]="jobTypeOptions"
                        [placeholder]="'Choose Job Types'"
                        [displayMemberPath]="'display'"
                        [checkedMemberPath]="'$checked'"
                        [showSelectAllCheckbox]="true"
                        [showFilterInput]="true"
                        [maxHeaderItems]="1"
                        (checkedItemsChanged)="applyFilters()"
                    ></wj-multi-select>
                </div>

                <div class="input-header-group">
                    <span class="input-header">Projection Start Month</span>
                    <wj-input-date
                        [(ngModel)]="projectionStartMonth"
                        name="jobTypeSummaryProjectionStartMonth"
                        (ngModelChange)="projectionStartMonthChanged()"
                        [selectionMode]="'Month'"
                        [format]="'MMM yyyy'"
                    ></wj-input-date>
                </div>

                <div class="input-header-group">
                    <span class="input-header">Amounts</span>
                    <label class="mb-0" style="font-weight: normal; line-height: 30px">
                        <input type="checkbox" name="includeProjected" [(ngModel)]="includeProjected" (ngModelChange)="applyFilters()" />
                        Include projected amounts for open jobs
                    </label>
                </div>

                @if (projectionStartMonthWarning) {
                    <span style="line-height: 30px; color: darkorange; margin-left: 10px">
                        {{ projectionStartMonthWarning }}
                    </span>
                }
            </form>
        </div>
    </div>

    <p class="text-muted" style="margin: 8px 0 0">
        GM is revenue minus these cost types. It can differ from the GP/GM tab, which uses Vista WIP gross profit.
    </p>

    <wj-flex-chart
        #summaryChart
        style="height: 480px"
        [itemsSource]="grid.view"
        [bindingX]="'jobType'"
        [chartType]="'Column'"
        [header]="'Percent of revenue by job type'"
        [legendToggle]="true"
    >
        <wj-flex-chart-legend [position]="'Bottom'"></wj-flex-chart-legend>
        <wj-flex-chart-axis [wjProperty]="'axisY'" [title]="'% of revenue'" [format]="'p0'"></wj-flex-chart-axis>
        <wj-flex-chart-axis wjProperty="axisX" [labelAngle]="-45"></wj-flex-chart-axis>
        <wj-flex-chart-series [binding]="'laborPercent'" [name]="'Labor'"></wj-flex-chart-series>
        <wj-flex-chart-series [binding]="'materialsPercent'" [name]="'Materials'"></wj-flex-chart-series>
        <wj-flex-chart-series [binding]="'equipmentPercent'" [name]="'Equipment'"></wj-flex-chart-series>
        <wj-flex-chart-series [binding]="'subcontractPercent'" [name]="'Subcontract'"></wj-flex-chart-series>
        <wj-flex-chart-series [binding]="'otherPercent'" [name]="'Other'"></wj-flex-chart-series>
        <wj-flex-chart-series [binding]="'overheadPercent'" [name]="'Overhead'"></wj-flex-chart-series>
        <wj-flex-chart-series [binding]="'gmPercent'" [name]="'GM %'"></wj-flex-chart-series>
    </wj-flex-chart>

    <div class="row">
        <div class="col-12">
            <wj-flex-grid
                id="jobTypeSummaryGrid"
                #summaryGrid
                appAutoSize
                [padding]="73"
                [frozenColumns]="1"
                (initialized)="grid.initialize(summaryGrid)"
                (destroy)="grid.destroy()"
                [itemsSource]="grid.view"
                [isReadOnly]="true"
            >
                <wj-flex-grid-filter></wj-flex-grid-filter>
                <wj-flex-grid-column [header]="'Job Type'" [binding]="'jobType'" [width]="200" [isReadOnly]="true"></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Revenue'"
                    [binding]="'revenue'"
                    [width]="130"
                    [format]="'C0'"
                    [align]="'right'"
                    [isReadOnly]="true"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Total Cost'"
                    [binding]="'totalCost'"
                    [width]="130"
                    [format]="'C0'"
                    [align]="'right'"
                    [isReadOnly]="true"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'GM $'"
                    [binding]="'gm'"
                    [width]="130"
                    [format]="'C0'"
                    [align]="'right'"
                    [isReadOnly]="true"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'GM %'"
                    [binding]="'gmPercent'"
                    [width]="90"
                    [format]="'p1'"
                    [align]="'right'"
                    [isReadOnly]="true"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Labor'"
                    [binding]="'labor'"
                    [width]="120"
                    [format]="'C0'"
                    [align]="'right'"
                    [isReadOnly]="true"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Labor %'"
                    [binding]="'laborPercent'"
                    [width]="90"
                    [format]="'p1'"
                    [align]="'right'"
                    [isReadOnly]="true"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Materials'"
                    [binding]="'materials'"
                    [width]="120"
                    [format]="'C0'"
                    [align]="'right'"
                    [isReadOnly]="true"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Materials %'"
                    [binding]="'materialsPercent'"
                    [width]="110"
                    [format]="'p1'"
                    [align]="'right'"
                    [isReadOnly]="true"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Equipment'"
                    [binding]="'equipment'"
                    [width]="120"
                    [format]="'C0'"
                    [align]="'right'"
                    [isReadOnly]="true"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Equipment %'"
                    [binding]="'equipmentPercent'"
                    [width]="110"
                    [format]="'p1'"
                    [align]="'right'"
                    [isReadOnly]="true"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Subcontract'"
                    [binding]="'subcontract'"
                    [width]="130"
                    [format]="'C0'"
                    [align]="'right'"
                    [isReadOnly]="true"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Subcontract %'"
                    [binding]="'subcontractPercent'"
                    [width]="120"
                    [format]="'p1'"
                    [align]="'right'"
                    [isReadOnly]="true"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Other'"
                    [binding]="'other'"
                    [width]="120"
                    [format]="'C0'"
                    [align]="'right'"
                    [isReadOnly]="true"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Other %'"
                    [binding]="'otherPercent'"
                    [width]="90"
                    [format]="'p1'"
                    [align]="'right'"
                    [isReadOnly]="true"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Overhead'"
                    [binding]="'overhead'"
                    [width]="120"
                    [format]="'C0'"
                    [align]="'right'"
                    [isReadOnly]="true"
                ></wj-flex-grid-column>
                <wj-flex-grid-column
                    [header]="'Overhead %'"
                    [binding]="'overheadPercent'"
                    [width]="110"
                    [format]="'p1'"
                    [align]="'right'"
                    [isReadOnly]="true"
                ></wj-flex-grid-column>
            </wj-flex-grid>
            <grid-selection-calculation [grid]="summaryGrid"></grid-selection-calculation>
        </div>
    </div>
</div>
